import { IonButton, IonButtons, IonContent, IonDatetime, IonHeader, IonIcon, IonItem, IonLabel, IonLoading, IonPage, IonPopover, IonSelect, IonSelectOption, IonTitle, IonToast, IonToolbar, isPlatform, useIonViewDidEnter } from '@ionic/react';
import { Buffer } from 'buffer';
import dayjs from 'dayjs';
import { arrowBack } from 'ionicons/icons';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import React, { useContext, useRef, useState } from 'react';
import { CSVLink } from "react-csv";
import { useHistory } from 'react-router-dom';
import { urlBaseCore } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import OperacoesTable from './OperacoesTable';
import OperacoesTableAgrupada from './OperacoesTableAgrupada';
import './RelatorioOperacoes.css';

type Props = {
  abrirMenu: boolean;
}

const RelatorioOperacoes: React.FC<Props> = (props: Props) => {

  const history = useHistory();
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");
  const [lojaSelecionadaId, setLojaSelecionadaId] = useState<string>(JSON.parse(window.localStorage.getItem("lojas") || "[]")[0]?.empresaLojaId || "");
  const [lojaSelecionadaNome, setLojaSelecionadaNome] = useState<string>(JSON.parse(window.localStorage.getItem("lojas") || "[]")[0]?.empresaLojaNome || "");
  // const [stateData, setStateData] = useState<any>(new Date().toISOString());
  const [stateLastEvaluatedKey, setStateLastEvaluatedKey] = useState<any>();
  const [stateOperacoes, setStateOperacoes] = useState<any>([]);
  const [stateOperacoesAgrupadas, setStateOperacoesAgrupadas] = useState<any>([]);
  const [stateCarregado, setStateCarregado] = useState<boolean>(false);
  const [stateStatus, setStateStatus] = useState<any>("Em");
  const [visualizacaoAgrupada, setVisualizacaoAgrupada] = useState<boolean>(false);

  const popover1 = useRef<HTMLIonPopoverElement>(null);
  const popover2 = useRef<HTMLIonPopoverElement>(null);

  const [showModalDataInicio, setShowModalDataInicio] = useState(false);
  const [showModalDataFim, setShowModalDataFim] = useState(false);

  const [dataAgendamentoPeriodo1, setDataAgendamentoPeriodo1] = useState<any>("Selecione");
  const [dataAgendamentoPeriodo1Br, setDataAgendamentoPeriodo1Br] = useState<any>("Selecione");
  const [dataAgendamentoPeriodo2, setDataAgendamentoPeriodo2] = useState<any>("Selecione");
  const [dataAgendamentoPeriodo2Br, setDataAgendamentoPeriodo2Br] = useState<any>("Selecione");

  const [showLoading, setShowLoading] = useState(false);
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const { nomeMenu, setNomeMenu } = useContext(MessageContext);

  useIonViewDidEnter(() => {
    setEsconderMenu(true);
    setNomeMenu("");
  });

  function tempoCorrido(horario: Date, dataFim?: Date) {
    var g = Math.ceil(((dataFim ? dataFim.getTime() : Date.now()) - horario.getTime()) / 1000 / 60);
    var tempoApurado = Math.floor(g / 60).toString() + 'h' + ('0' + (g % 60).toString()).substr(-2) + 'min';
    return tempoApurado !== "0h00min" ? tempoApurado : "0h01min";
  }

  async function carregarOperacoesSegmentada(filtro: any, lojasParam: any, data: string) {
    const consultar = async () => {

      if (dataAgendamentoPeriodo1Br == "Selecione" || dataAgendamentoPeriodo2Br == "Selecione") {
        setTextToast("Todos os campos são obrigatórios.");
        setShowToast(true);
        return null;
      }

      let data1 = new Date(dataAgendamentoPeriodo1).getTime();
      let data2 = new Date(dataAgendamentoPeriodo2).getTime();

      var msDiff = data2 - data1;
      var msDiffDay = Math.floor(msDiff / (1000 * 60 * 60 * 24));

      if (msDiffDay < 0) {
        setTextToast("Data fim não pode ser menor que Data início.");
        setShowToast(true);
        return null;
      }
      else if (msDiffDay > 31) {
        setTextToast("Intervalo da data não pode ser maior que 31 dias.");
        setShowToast(true);
        return null;
      }

      setStateCarregado(true);
      setShowLoading(true);

      let token: string = "";
      const tkn = localStorage.getItem("token");
      if (typeof (tkn) === "string") {
        token = tkn;
      }

      let dataFormatada = dayjs(dataAgendamentoPeriodo1).format('YYYY-MM-DD');
      let dataFormatada2 = dayjs(dataAgendamentoPeriodo2).format('YYYY-MM-DD');


      let urlFinal = urlBaseCore.url + "/operacoes/relatorio?campo=data" +
        "&valor=" + dataFormatada +
        "&valor2=" + dataFormatada2 +
        "&filtro=" + filtro +
        "&lojas=" + Buffer.from(lojasParam).toString('base64');

      const resp: Response = await fetch(urlFinal,
        {
          method: urlBaseCore.method,
          headers: [
            ["token", token]
          ],
          credentials: 'include'
        });

      let res = await resp.json();

      if (resp.status === 400 || resp.status === 401) {
        history.replace("/login/");
      }

      if (res && res.LastEvaluatedKey) {
        setStateLastEvaluatedKey(res.LastEvaluatedKey);
      }
      else {
        setStateLastEvaluatedKey(null);
      }

      setShowLoading(false);
      if (res && res.Items) {
        return res.Items;
      }
      else {
        return null;
      }
    };
    return await consultar();
  }

  async function carregarDados(situacao: any, cliente: any, data: any, exportFunction?: any) {
    let loadResult = await carregarOperacoesSegmentada(situacao, cliente, data);
    let arrayOperacoes: any[] = [];

    arrayOperacoes.push(['#', 'Operação', 'Tipo', 'Chegada', 'Término', 'Duração', 'Cliente', 'Telefone', 'Avaliação', 'Comentário', 'Colaborador', 'Telefone', 'Avaliação', 'Comentário', 'Placa Veículo', 'Taxa Entrega']);

    let contador = 0;

    if (loadResult) {

      let somaTaxaEntrega = 0;
      loadResult.map((valor: any, index: any) => {
        contador++;

        let BRNumberCliente = "";
        if (valor.clienteTelefone?.length == 13) {
          BRNumberCliente = valor.clienteTelefone.replace("55", "").match(/(\d{2})(\d{5})(\d{4})/);
          BRNumberCliente = "(" + BRNumberCliente[1] + ") " + BRNumberCliente[2] + "-" + BRNumberCliente[3];
        }

        let BRNumberPrestador = "";
        if (valor.prestadorTelefone?.length == 13) {
          BRNumberPrestador = valor.prestadorTelefone.replace("55", "").match(/(\d{2})(\d{5})(\d{4})/);
          BRNumberPrestador = "(" + BRNumberPrestador[1] + ") " + BRNumberPrestador[2] + "-" + BRNumberPrestador[3];
        }
        arrayOperacoes.push(
          [
            contador,
            valor.descricaoAgendamento || "-",
            valor.tipoOperacao || "-",
            dayjs(valor.dataInicio).format('DD/MM/YYYY HH:mm') || "-",
            dayjs(valor.dataEncerramento).format('DD/MM/YYYY HH:mm') || "-",
            tempoCorrido(new Date(valor.dataInicio), valor.dataEncerramento ? new Date(valor.dataEncerramento) : new Date()) || "-",
            valor.clienteNome || "-",
            BRNumberCliente || "-",
            valor.avaliacaoCliente || "Não avaliado",
            valor.comentarioCliente || "Não avaliado",


            valor.motoristaNome || "-",
            BRNumberPrestador || "-",
            valor.avaliacao || "Não avaliado",
            valor.comentario || "Não avaliado",
            valor.veiculo || "-",
            valor.taxaEntrega || "-"
          ]);

        somaTaxaEntrega += valor.taxaEntrega ? parseFloat(valor.taxaEntrega?.replace(/\./g, '').replace(/\,/g, '.')) : 0;

      });

      arrayOperacoes.push(
        [
          "-",
          "-",
          "-",
          "-",
          "-",
          "-",
          "-",
          "-",
          "-",
          "-",
          "-",
          "-",
          "-",
          "-",
          "-",
          (somaTaxaEntrega || 0).toLocaleString('pt-br', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })
        ]);

      setStateOperacoes(arrayOperacoes);

      // Criar tabela agrupado por colaborador
      const agrupamentoPorColaborador: any = {};

      loadResult.forEach((valor: any) => {
        const colaboradorNome = valor.motoristaNome || "Sem colaborador";
        // Usa o pk do motorista, ou o nome como fallback para garantir agrupamento único
        const colaboradorId = valor.motoristaPk || valor.prestadorId || `nome-${colaboradorNome}`;
        const taxaEntrega = valor.taxaEntrega ? parseFloat(valor.taxaEntrega?.replace(/\./g, '').replace(/\,/g, '.')) : 0;

        if (!agrupamentoPorColaborador[colaboradorId]) {
          agrupamentoPorColaborador[colaboradorId] = {
            nome: colaboradorNome,
            telefone: valor.prestadorTelefone || "-",
            quantidadeOperacoes: 0,
            totalTaxas: 0
          };
        }

        agrupamentoPorColaborador[colaboradorId].quantidadeOperacoes += 1;
        agrupamentoPorColaborador[colaboradorId].totalTaxas += taxaEntrega;
      });

      // Converter para array e ordenar por nome
      const arrayAgrupado: any[] = [];
      arrayAgrupado.push(['#', 'Colaborador', 'Quantidade Operações', 'Total Taxa Entrega']);

      let contadorAgrupado = 0;
      let somaTotalGeral = 0;
      let somaQuantidadeGeral = 0;

      Object.keys(agrupamentoPorColaborador)
        .sort((a, b) => agrupamentoPorColaborador[a].nome.localeCompare(agrupamentoPorColaborador[b].nome))
        .forEach((key) => {
          contadorAgrupado++;
          const item = agrupamentoPorColaborador[key];

          arrayAgrupado.push([
            contadorAgrupado,
            item.nome,
            item.quantidadeOperacoes,
            item.totalTaxas.toLocaleString('pt-br', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })
          ]);

          somaTotalGeral += item.totalTaxas;
          somaQuantidadeGeral += item.quantidadeOperacoes;
        });

      // Adicionar linha de totais
      arrayAgrupado.push([
        "-",
        "TOTAL",
        somaQuantidadeGeral,
        somaTotalGeral.toLocaleString('pt-br', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
      ]);

      setStateOperacoesAgrupadas(arrayAgrupado);

      if (exportFunction) {
        exportFunction(arrayOperacoes);
      }
    }
  }

  async function gerarRelatorioPDF(arrayOperacoes: any) {

     (pdfMake as any).vfs = (pdfFonts as any).pdfMake.vfs;

    const reportTitle: any = [{
      text: 'Operações',
      fontSize: 15,
      bold: true,
      margin: [15, 20, 0, 45]  // left, top, riight, bottom
    }];

    const reportDetails: any = [
      { text: lojaSelecionadaNome, style: 'subheader' },
      { text: 'Data início: ' + new Date(dataAgendamentoPeriodo1 || "").toLocaleString("pt-BR").substring(0, 10), style: 'subheader' },
      { text: 'Data fim: ' + new Date(dataAgendamentoPeriodo2 || "").toLocaleString("pt-BR").substring(0, 10), style: 'subheader' },
      { text: 'Status: ' + (stateStatus == "Em" ? "Em Andamento" : "Encerrados"), style: 'subheader' },
      {
        table: {
          body: arrayOperacoes

        },
        layout: {
          fillColor: function (rowIndex: any, node: any, columnIndex: any) {
            return (rowIndex == 0) ? '#ff7000' : (rowIndex % 2 === 0) ? '#CCCCCC' : null;
          }
        },
        style: 'padrao'
      }
    ];

    const reportFooter: any = [];

    function rodape(currentPage: any, pageCount: any) {
      return [
        {
          text: currentPage + ' / ' + pageCount,
          alignment: 'right',
          fontSize: 9,
          margin: [0, 10, 20, 0]
        }
      ]
    }

    const docDefinitions: any = {
      pageSize: 'A4',

      pageOrientation: 'landscape',

      pageMargin: [15, 50, 15, 40],

      content: [reportDetails],
      footer: rodape,
      styles: {
        header: {
          fontSize: 10,
          bold: true
        },
        subheader: {
          fontSize: 10,
          bold: true,
          margin: [0, 10, 0, 5]
        },
        padrao: {
          fontSize: 8
        }
      }
    }

    pdfMake.createPdf(docDefinitions).open();
  }

  const openPopoverInicio = (e: any) => {
    popover1.current!.event = e;
    setShowModalDataInicio(true);
  };


  const openPopoverFim = (e: any) => {
    popover2.current!.event = e;
    setShowModalDataFim(true);
  };


  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonButton onClick={() => { setStateOperacoes([]); setStateCarregado(false); history.goBack(); }}><IonIcon slot="icon-only" icon={arrowBack} /></IonButton>
          </IonButtons>
          {/* <IonButtons slot="start">
            <IonButton>
              <IonIcon slot="icon-only" icon={flag} />
            </IonButton>
          </IonButtons> */}
          <IonTitle slot="start">Relatório Operações</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent color="light">
        <div style={{ textAlign: "center" }} hidden={stateCarregado}>
          <IonItem>
            <IonLabel>Data início</IonLabel>
            <IonLabel style={{ "color": "#BDBDBD" }} slot="end" onClick={e => { openPopoverInicio(e); }}>{dataAgendamentoPeriodo1Br}</IonLabel>
          </IonItem>


          <IonItem>
            <IonLabel>Data fim</IonLabel>
            <IonLabel style={{ "color": "#BDBDBD" }} slot="end" onClick={e => { openPopoverFim(e); }}>{dataAgendamentoPeriodo2Br}</IonLabel>
          </IonItem>
          <IonItem hidden={(window.localStorage.getItem("lojas") && JSON.parse(window.localStorage.getItem("lojas") || "").length > 1) ? false : true}>
            <IonLabel>Loja</IonLabel>
            <IonSelect name='Lojas' placeholder='Selecione as lojas' title='Lojas' value={lojaSelecionadaId} multiple={false} cancelText="Cancel" okText="Ok" onIonChange={e => {

              let found = JSON.parse(window.localStorage.getItem("lojas") || "[]").find((obj: any) => {
                return obj.empresaLojaId === e.detail.value;
              });
              if (found) {
                setLojaSelecionadaNome(found.empresaLojaNome);
              }
              setLojaSelecionadaId(e.detail.value);

            }} slot="end">
              {JSON.parse(window.localStorage.getItem("lojas") || "[]").map((valor: any) => (
                <IonSelectOption key={"lojaid" + valor.empresaLojaId} value={valor.empresaLojaId}>{valor.empresaLojaNome}</IonSelectOption>
              ))}
            </IonSelect>
          </IonItem>
          <IonItem hidden={false}>
            <IonLabel>Status</IonLabel>
            <IonSelect style={{ "color": "#BDBDBD" }} value={stateStatus} onIonChange={(e) => { setStateStatus(e.detail.value); }}>
              <IonSelectOption value={'Em'}>Andamento</IonSelectOption>
              <IonSelectOption value={'Encerrado'}>Encerrados</IonSelectOption>

            </IonSelect>
          </IonItem>

          <p></p>
          <IonButton onClick={async () => { await carregarDados(stateStatus, lojaSelecionadaId, dataAgendamentoPeriodo1) }} expand="block" type="submit" fill='solid' color='tertiary'>Buscar</IonButton>
        </div>
        <div style={{ textAlign: "center" }} hidden={!stateCarregado}>
          <IonItem lines='none'>
            <IonLabel style={{ textAlign: 'center' }}>{lojaSelecionadaNome}</IonLabel>
          </IonItem>
          <IonItem lines='none'>
            <IonLabel style={{ textAlign: 'center' }}>Data início: {dayjs(dataAgendamentoPeriodo1).format("DD/MM/YYYY")}</IonLabel>
          </IonItem>
          <IonItem lines='none'>
            <IonLabel style={{ textAlign: 'center' }}>Data fim: {dayjs(dataAgendamentoPeriodo2).format("DD/MM/YYYY")}</IonLabel>
          </IonItem>
          <IonItem lines='none'>
            <IonLabel style={{ textAlign: 'center' }}>Status: {stateStatus == "Em" ? "Em Andamento" : "Encerrados"}</IonLabel>
          </IonItem>
          <p></p>
          <IonButton onClick={() => {
            setStateOperacoes([]);
            setStateOperacoesAgrupadas([]);
            setStateCarregado(false);
            setVisualizacaoAgrupada(false);
          }} type="button" fill='solid' color='tertiary'>Limpar</IonButton>
          <IonButton hidden={isPlatform("android") || isPlatform("ios")} onClick={() => gerarRelatorioPDF(visualizacaoAgrupada ? stateOperacoesAgrupadas : stateOperacoes)} type="button" fill='solid' color='tertiary'>Gerar PDF</IonButton>
          <CSVLink hidden={isPlatform("android") || isPlatform("ios")} data={visualizacaoAgrupada ? stateOperacoesAgrupadas : stateOperacoes} separator={";"}><IonButton type="button" fill='solid' color='tertiary'>Gerar CSV</IonButton></CSVLink>

          <p></p>
          <IonItem lines='none' style={{ textAlign: 'center' }}>
            <IonSelect 
              interface="popover"
              style={{ textAlign: 'center', width: '100%', justifyContent: 'center' }}
              value={visualizacaoAgrupada ? "agrupado" : "detalhado"} 
              onIonChange={(e) => { setVisualizacaoAgrupada(e.detail.value === "agrupado"); }}
            >
              <IonSelectOption value="detalhado">Detalhado</IonSelectOption>
              <IonSelectOption value="agrupado">Agrupado</IonSelectOption>
            </IonSelect>
          </IonItem>
          <p></p>
          {visualizacaoAgrupada ? (
            <OperacoesTableAgrupada model={stateOperacoesAgrupadas}></OperacoesTableAgrupada>
          ) : (
            <OperacoesTable model={stateOperacoes}></OperacoesTable>
          )}
        </div>
        <p></p>

        <IonPopover ref={popover1}
          isOpen={showModalDataInicio}
          onDidDismiss={() => setShowModalDataInicio(false)} >
          <IonContent>
            <IonDatetime
              presentation='date'
              onIonChange={e => {
                if (e.detail.value) {
                  let data = e.detail.value.toString().substring(0, 10);
                  const dataFormatada = new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(
                    Date.parse(data)
                  );
                  setDataAgendamentoPeriodo1Br(dataFormatada);
                  setDataAgendamentoPeriodo1(data);
                }
                //setShowModalDataInicio(false);
              }}></IonDatetime>
          </IonContent>
        </IonPopover >


        <IonPopover ref={popover2}
          isOpen={showModalDataFim}
          onDidDismiss={() => setShowModalDataFim(false)} >
          <IonContent>
            <IonDatetime
              presentation='date'
              onIonChange={e => {
                if (e.detail.value) {
                  let data = e.detail.value.toString().substring(0, 10);
                  const dataFormatada = new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(
                    Date.parse(data)
                  );
                  setDataAgendamentoPeriodo2Br(dataFormatada);
                  setDataAgendamentoPeriodo2(data);
                }
                //setShowModalDataFim(false);
              }}></IonDatetime>
          </IonContent>
        </IonPopover >

        <IonToast
          isOpen={showToast}
          position="middle" //top, bottom, middle
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'

        />
      </IonContent>
    </IonPage>
  );
};

export default RelatorioOperacoes;